import { HttpParams } from '@angular/common/http';
import { isEmpty } from 'lodash';

export class ClientLibraryFilterParamsUtils {
  private static readonly clientLibraryFilterConfig: Record<
    string,
    { expand?: string; fields: string }
  > = {
    form_group: {
      expand: 'template.category',
      fields: 'template.category.name,template.category.id',
    },
    title: {
      fields: 'title',
    },
    assigned_provider: {
      expand: 'assigned_provider',
      fields: 'assigned_provider.first_name,assigned_provider.last_name,assigned_provider.id',
    },
    status: {
      fields: 'status,shared_with_patient',
    },
    shared_with_patient: {
      fields: 'shared_with_patient',
    },
  };

  public static getClientLibraryFilterParams(field: string, params: HttpParams): HttpParams {
    const config = ClientLibraryFilterParamsUtils.clientLibraryFilterConfig[field];

    if (isEmpty(config)) {
      return params;
    }

    const queryParams = config?.expand ? params.set('expand', config.expand) : params;
    return queryParams.set('fields', config.fields);
  }
}
